import React from "react";

export default function InternalRating({ rating }: any) {
  function getInternalRatingCount(rating: string): number {
    const match = rating.match(/^(\d+)/);
    if (!match) return 0;
    return parseInt(match[1], 10);
  }

  const count = getInternalRatingCount(rating);

  const binoIcon = (
    <img
      key="bino"
      src="https://firebasestorage.googleapis.com/v0/b/plutonios-prod.appspot.com/o/HM%2Fbino-icon.svg?alt=media&token=dcdb01fc-d105-4aff-b2ee-74974472993c"
      alt="Bino Icon"
      style={{ marginRight: "2px", marginTop: "0.5rem" }}
    />
  );

  const binoPlusIcon = (
    <img
      key="bino-plus"
      src="https://firebasestorage.googleapis.com/v0/b/plutonios-prod.appspot.com/o/HM%2Fbino_plus.svg?alt=media&token=f493f183-6de3-4049-a2da-accece7224c7"
      alt="Bino Plus Icon"
      style={{ marginRight: "2px", marginBottom: "0.5rem", width: "0.7rem" }}
    />
  );

  const icons = Array.from({ length: count }, (_, i) =>
    React.cloneElement(binoIcon, { key: `bino-${i}` })
  );

  if (rating.endsWith("+")) {
    icons.push(binoPlusIcon);
  }

  return <div className="message-template-rating">{icons}</div>;
}
